import { useState, useEffect } from 'react';
import { useLazyLoadQuery } from 'react-relay';
import { StudentsDataTableFiltersQuery } from '../../graphQLOperations/__generated__/StudentsDataTableFiltersQuery.graphql';
import { getStudentTableFiltersInfo } from '../../graphQLOperations/StudentsDataTable';
import { useHiddenClassIds } from '../../custom-hooks/useHiddenClassIds';
import { ClassNameSection } from '../../models/Class';

interface Props {
  classes: { nodes: ClassNameSection[] };
  setClasses: (classes: { nodes: ClassNameSection[] }) => void;
}

const QueryGetAllClasses = ({ classes, setClasses }: Props) => {
  const hiddenClassIds = useHiddenClassIds();
  const [fetchKey, setFetchKey] = useState<number>(0);
  const [lazyLoading, setLazyLoading] = useState<boolean>(true);
  const [pageInfo, setPageInfo] = useState<
    | {
        endCursor: string | null | undefined;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor: string | null | undefined;
      }
    | undefined
  >(undefined);
  const first = 100;
  const after = lazyLoading && pageInfo?.hasNextPage ? pageInfo?.endCursor : undefined;

  const { classes: classesQuery } = useLazyLoadQuery<StudentsDataTableFiltersQuery>(
    getStudentTableFiltersInfo,
    {
      skip: !lazyLoading,
      first,
      after,
    },
    { fetchPolicy: 'network-only', fetchKey },
  );

  useEffect(() => {
    if (classesQuery && classesQuery?.nodes && lazyLoading) {
      const nodes = (classesQuery.nodes as ClassNameSection[]).filter(cls => !hiddenClassIds.has(cls.id));
      setPageInfo(classesQuery?.pageInfo);
      setLazyLoading(false);
      setClasses(classes?.nodes?.length > 99 ? { nodes: [...classes.nodes, ...nodes] } : { nodes });
    }
  }, [classesQuery, lazyLoading]);

  useEffect(() => {
    if (pageInfo?.hasNextPage) {
      setLazyLoading(true);
      setFetchKey(prev => prev + 1);
    }
  }, [pageInfo?.hasNextPage]);

  return <div style={{ display: 'none' }}></div>;
};

export default QueryGetAllClasses;
